import { useRef } from 'react'
import { z } from 'zod'
import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'

const contatoFormSchema = z.object({
 contato: z.object({
  nome: z.string().min(1, 'Nome Completo é obrigatório!'),
  email: z
   .string()
   .min(1, 'E-mail é obrigatório!')
   .email('Digite um e-mail válido'),
  assunto: z.string().min(1, 'Assunto é obrigatório!'),
  mensagem: z
   .string()
   .trim()
   .min(1, 'Mensagem é obrigatória!')
   .min(10, 'Digite no mínimo 10 caracteres')
 })
})

type ContatoFormData = z.infer<typeof contatoFormSchema>

export function Form() {
 const textareaRef = useRef<HTMLTextAreaElement>(null)

 function handleTextArea() {
  const textarea = textareaRef.current
  if (textarea) {
   textarea.style.height = 'auto'
   textarea.style.height = `${textarea.scrollHeight}px`
  }
 }

 const {
  register,
  handleSubmit,
  formState: { isSubmitting, errors }
 } = useForm<ContatoFormData>({
  resolver: zodResolver(contatoFormSchema),
  mode: 'all'
 })

 const { ref: registerRef, ...rest } = register('contato.mensagem')

 async function SendContatoFormData(data: ContatoFormData) {
  console.log(data)
 }

 return (
  <div className="w-full py-10">
   <form
    className="flex gap-12 max-[768px]:gap-0 max-[768px]:flex-col"
    onSubmit={handleSubmit(SendContatoFormData)}
   >
    <div className="min-[768px]:w-1/2 max-[767px]:w-full">
     <div className="w-full mb-6 relative">
      <input
       type="text"
       id="contato[nome]"
       {...register('contato.nome')}
       className={
        errors.contato?.nome?.message
         ? "font-['rns-milesregular'] font-normal text-red-600 text-lg w-full block pt-8 leading-6 transition-all duration-150 ease-in-out box-border shadow-none outline-none bg-transparent border-b-[1px]  border-red-600 rounded-none"
         : "font-['rns-milesregular'] font-normal text-black text-lg w-full block pt-8 leading-6 transition-all duration-150 ease-in-out box-border shadow-none outline-none bg-transparent border-b-[1px]  border-black rounded-none"
       }
       autoComplete="off"
      />
      {errors.contato?.nome?.message && (
       <p className="pt-1 text-left text-sm text-red-600">
        {errors.contato.nome.message}
       </p>
      )}
      <label
       htmlFor="contato[nome]"
       className={
        errors.contato?.nome?.message
         ? "absolute top-1.5 left-0 text-red-600 max-[499px]:text-sm text-base uppercase transition-all duration-500 pointer-events-none font-['rns-milesblack'] font-bold tracking-wider"
         : "absolute top-1.5 left-0 text-black max-[499px]:text-sm text-base uppercase transition-all duration-500 pointer-events-none font-['rns-milesblack'] font-bold tracking-wider"
       }
      >
       Nome
      </label>
     </div>
     <div className="w-full mb-6 relative">
      <input
       type="email"
       id="contato[email]"
       {...register('contato.email')}
       className={
        errors.contato?.email?.message
         ? "font-['rns-milesregular'] font-normal text-red-600 text-lg w-full block pt-8 leading-6 transition-all duration-150 ease-in-out box-border shadow-none outline-none bg-transparent border-b-[1px]  border-red-600 rounded-none"
         : "font-['rns-milesregular'] font-normal text-black text-lg w-full block pt-8 leading-6 transition-all duration-150 ease-in-out box-border shadow-none outline-none bg-transparent border-b-[1px]  border-black rounded-none"
       }
       autoComplete="off"
      />
      {errors.contato?.email?.message && (
       <p className="pt-1 text-left text-sm text-red-600">
        {errors.contato.email.message}
       </p>
      )}
      <label
       htmlFor="contato[email]"
       className={
        errors.contato?.email?.message
         ? "absolute top-1.5 left-0 text-red-600 max-[499px]:text-sm text-base uppercase transition-all duration-500 pointer-events-none font-['rns-milesblack'] font-bold tracking-wider"
         : "absolute top-1.5 left-0 text-black max-[499px]:text-sm text-base uppercase transition-all duration-500 pointer-events-none font-['rns-milesblack'] font-bold tracking-wider"
       }
      >
       E-mail
      </label>
     </div>
     <div className="w-full mb-6 relative">
      <input
       type="text"
       id="contato[assunto]"
       {...register('contato.assunto')}
       className={
        errors.contato?.assunto?.message
         ? "font-['rns-milesregular'] font-normal text-red-600 text-lg w-full block pt-8 leading-6 transition-all duration-150 ease-in-out box-border shadow-none outline-none bg-transparent border-b-[1px]  border-red-600 rounded-none"
         : "font-['rns-milesregular'] font-normal text-black text-lg w-full block pt-8 leading-6 transition-all duration-150 ease-in-out box-border shadow-none outline-none bg-transparent border-b-[1px]  border-black rounded-none"
       }
       autoComplete="off"
      />
      {errors.contato?.assunto?.message && (
       <p className="pt-1 text-left text-sm text-red-600">
        {errors.contato.assunto.message}
       </p>
      )}
      <label
       htmlFor="contato[assunto]"
       className={
        errors.contato?.assunto?.message
         ? "absolute top-1.5 left-0 text-red-600 max-[499px]:text-sm text-base uppercase transition-all duration-500 pointer-events-none font-['rns-milesblack'] font-bold tracking-wider"
         : "absolute top-1.5 left-0 text-black max-[499px]:text-sm text-base uppercase transition-all duration-500 pointer-events-none font-['rns-milesblack'] font-bold tracking-wider"
       }
      >
       Assunto
      </label>
     </div>
    </div>
    <div className="min-[768px]:w-1/2 max-[767px]:w-full flex flex-col justify-between">
     <div className="w-full mb-6 relative">
      <textarea
       id="contato[mensagem]"
       {...rest}
       className={
        errors.contato?.mensagem?.message
         ? "font-['rns-milesregular'] font-normal text-red-600 text-lg w-full min-h-[56px] block pt-8 leading-6 transition-all duration-150 ease-in-out box-border shadow-none outline-none bg-transparent border-b-[1px]  border-red-600 rounded-none overflow-hidden"
         : "font-['rns-milesregular'] font-normal text-black text-lg w-full min-h-[56px] block pt-8 leading-6 transition-all duration-150 ease-in-out box-border shadow-none outline-none bg-transparent border-b-[1px]  border-black rounded-none overflow-hidden"
       }
       ref={el => {
        registerRef(el)
        textareaRef.current = el
        if (el) {
         el.style.height = 'auto'
         el.style.height = `${el.scrollHeight}px`
        }
       }}
       onInput={handleTextArea}
       rows={1}
      />
      {errors.contato?.mensagem?.message && (
       <p className="pt-1 text-left text-sm text-red-600">
        {errors.contato.mensagem.message}
       </p>
      )}
      <label
       htmlFor="contato[mensagem]"
       className={
        errors.contato?.mensagem?.message
         ? "absolute top-1.5 left-0 text-red-600 max-[499px]:text-sm text-base uppercase transition-all duration-500 pointer-events-none font-['rns-milesblack'] font-bold tracking-wider"
         : "absolute top-1.5 left-0 text-black max-[499px]:text-sm text-base uppercase transition-all duration-500 pointer-events-none font-['rns-milesblack'] font-bold tracking-wider"
       }
      >
       Mensagem
      </label>
     </div>
     <div className="w-full relative">
      <button
       type="submit"
       disabled={isSubmitting}
       className="bg-black font-['rns-milesblack'] cursor-pointer text-white font-bold uppercase text-center w-full rounded-none border-0 p-1.5 px-3 text-base leading-6 hover:bg-neutral-700"
      >
       {isSubmitting ? 'Enviando...' : 'Enviar'}
      </button>
     </div>
    </div>
   </form>
  </div>
 )
}
